import { AnimatePresence } from "motion/react";
import { FC } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { AccessControl } from "@ryde/controls";
import { AddNewFormGeneric, AnimatedPage } from "@ryde/layout";
import { usePageContext } from "@ryde/redux";

import { BookingEdit } from "../crud";

export const BookingCrudeRoutes: FC = () => {
  const { entity } = usePageContext();

  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="new"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                <AddNewFormGeneric entity={entity} />
              </AnimatedPage>
            </AccessControl>
          }
        />
        <Route
          path="add"
          element={
            <AccessControl entity={entity} action="create">
              <AnimatedPage>
                <BookingEdit isAddRoute={true} />
              </AnimatedPage>
            </AccessControl>
          }
        />
        <Route
          path="add/:id"
          element={
            <AccessControl entity={entity} action="update">
              <AnimatedPage>
                <BookingEdit isAddRoute={true} />
              </AnimatedPage>
            </AccessControl>
          }
        />
        <Route
          path="edit/:id"
          element={
            <AccessControl entity={entity} action="read">
              <AnimatedPage>
                <BookingEdit />
              </AnimatedPage>
            </AccessControl>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};
